document.addEventListener("DOMContentLoaded", function () {
  // Cambiar los colores
  const errorColor = [
    "border-red-500",
    "focus:outline-none",
    "focus:ring-0",
    "border-red-600",
    "focus:border-red-600",
    "dark:focus:border-red-500",
  ];

  // Nombre y apellido
  let filled_error_name = document.getElementById("nombres_y_apellidos");
  let filled_error_help_name = document.getElementById(
    "filled_error_help_name"
  );
  let filled_error_help_name2 = document.getElementById(
    "filled_error_help_name2"
  );
  let filled_error_help_name3 = document.getElementById(
    "filled_error_help_name3"
  );
  let filled_error_help_name4 = document.getElementById(
    "filled_error_help_name4"
  );

  // Correo electronico
  const regexCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let filled_error_email = document.getElementById("correo_electronico");
  let filled_error_help_email = document.getElementById(
    "filled_error_help_email"
  );

  // Celular
  let filled_error_celular = document.getElementById("celular");
  let filled_error_help_tel = document.getElementById("filled_error_help_tel");

  //Categorias

  let filled_error_categoria = document.getElementById("categoria");
  let filled_help_error_categoria = document.getElementById(
    "filled_help_error_categoria"
  );

  //Productos

  let filled_error_producto = document.getElementById("producto");
  let filled_help_error_producto = document.getElementById(
    "filled_help_error_producto"
  );

  // Validacion nombres y apellidos
  const regexName = /^[A-Za-zÀ-ÿ\s]+$/; // Permitir letras, incluyendo tildes y ñ

  // Validacion nombres y apellidos
  filled_error_name.addEventListener("input", function (event) {
    // Reemplaza caracteres no permitidos (números y caracteres especiales)
    let value = filled_error_name.value.replace(/[^A-Za-zÀ-ÿ\s]/g, "");
    filled_error_name.value = value; // Actualiza el valor del campo de entrada

    const trimmedValue = filled_error_name.value.trim();
    const spaceCount = (trimmedValue.match(/\s+/g) || []).length;

    if (trimmedValue === "") {
      // Si el campo está vacío
      filled_error_help_name.classList.add("hidden");
      filled_error_help_name2.classList.add("hidden");
      filled_error_help_name3.classList.add("hidden");
      filled_error_help_name4.classList.remove("hidden");
      filled_error_name.classList.remove(...errorColor);
    }
    else if (trimmedValue.length > 0 && trimmedValue.length < 5) {
      // Si el nombre es muy corto
      filled_error_help_name.classList.remove("hidden");
      filled_error_help_name2.classList.add("hidden");
      filled_error_help_name3.classList.add("hidden");
      filled_error_help_name4.classList.add("hidden");

      filled_error_name.classList.add(...errorColor);
    } else if (!regexName.test(trimmedValue)) {
      // Si el nombre contiene caracteres no válidos
      filled_error_help_name.classList.add("hidden");
      filled_error_help_name2.classList.remove("hidden");
      filled_error_help_name3.classList.add("hidden");
      filled_error_help_name4.classList.add("hidden");
      filled_error_name.classList.add(...errorColor);
    } else if (spaceCount < 1) {
      // Si no contiene al menos un espacio (nombre compuesto)
      filled_error_help_name.classList.add("hidden");
      filled_error_help_name2.classList.add("hidden");
      filled_error_help_name3.classList.remove("hidden");
      filled_error_help_name4.classList.add("hidden");
      filled_error_name.classList.add(...errorColor);
      event.preventDefault(); // Evitar que el formulario se envíe
    } else {

      // Todo está bien
      filled_error_help_name.classList.add("hidden");
      filled_error_help_name2.classList.add("hidden");
      filled_error_help_name3.classList.add("hidden");
      filled_error_help_name4.classList.add("hidden");
      filled_error_name.classList.remove(...errorColor);
    }
  });

  // Validacion nombres y apellidos campo vacio

  filled_error_name.addEventListener("blur", function () {
    if (filled_error_name.value.trim() === "") {
      filled_error_help_name4.classList.remove("hidden");
      filled_error_name.classList.add(...errorColor);
    } else {
      filled_error_help_name4.classList.add("hidden");
      filled_error_name.classList.remove(...errorColor);
    }
  });


  // Categoias
  filled_error_categoria.addEventListener("input", function () {

    const trimmedValueCategory = filled_error_categoria.value.trim()

    if (trimmedValueCategory !== "") {
      filled_help_error_categoria.classList.add("hidden");
      filled_error_categoria.classList.remove(...errorColor);
    }

  })

  // Productos
  filled_error_producto.addEventListener("input", function () {

    const trimmedValueProduct = filled_error_producto.value.trim()

    if (trimmedValueProduct !== "") {
      filled_help_error_producto.classList.add("hidden");
      filled_error_producto.classList.remove(...errorColor);
    }

  })

  const validateEmail = () => {
    if (
      filled_error_email.value.trim() === ""
    ) {
      filled_error_help_email.classList.remove("hidden");
      filled_error_email.classList.add(...errorColor);
    }
    else if (!regexCorreo.test(filled_error_email.value.trim())) {
      filled_error_help_email.classList.remove("hidden");
      filled_error_email.classList.add(...errorColor);
    }
    else {
      filled_error_help_email.classList.add("hidden");
      filled_error_email.classList.remove(...errorColor);
    }
  }

  // Validacion correo electronico
  filled_error_email.addEventListener("input", function () {

    validateEmail()

  });


  // Validacion correo electronico campo vacio

  filled_error_email.addEventListener("blur", function () {
    validateEmail()
  })

  //Validacion celular campo vacio entra y sale no copia nada

  filled_error_celular.addEventListener("blur", function () {
    if (filled_error_celular.value.trim() === "") {
      filled_error_help_tel.classList.remove("hidden");
      filled_error_celular.classList.add(...errorColor);
    } else {
      filled_error_help_tel.classList.add("hidden");
      filled_error_celular.classList.remove(...errorColor);
    }
  });

  // Validacion campo vacio al enviar el formulario

  document
    .getElementById("form-contact-chat")
    .addEventListener("submit", function (event) {
      //Validacion campo name
      if (filled_error_name.value.trim() === "") {
        filled_error_name.classList.add(...errorColor);
        filled_error_help_name4.classList.remove("hidden");
      } else {
        filled_error_name.classList.remove(...errorColor);
        filled_error_help_name4.classList.add("hidden");
      }

      //Validacion campo correo

      if (filled_error_email.value.trim() === "") {
        filled_error_help_email.classList.remove("hidden");
        filled_error_email.classList.add(...errorColor);
      } else {
        filled_error_help_email.classList.add("hidden");
        filled_error_email.classList.remove(...errorColor);
      }

      // Validacion campo celular

      if (filled_error_celular.value.trim() === "") {
        filled_error_help_tel.classList.remove("hidden");
        filled_error_celular.classList.add(...errorColor);
      } else {
        filled_error_help_tel.classList.add("hidden");
        filled_error_celular.classList.remove(...errorColor);
      }

      //Validacion categoria

      if (filled_error_categoria.value.trim() === "") {
        filled_help_error_categoria.classList.remove("hidden");
        filled_error_categoria.classList.add(...errorColor);
      } else {
        filled_help_error_categoria.classList.add("hidden");
        filled_error_categoria.classList.remove(...errorColor);
      }

      //Validacion Productos

      if (filled_error_producto.value.trim() === "") {
        filled_help_error_producto.classList.remove("hidden");
        filled_error_producto.classList.add(...errorColor);
      } else {
        filled_help_error_producto.classList.add("hidden");
        filled_error_producto.classList.remove(...errorColor);
      }
    });

  // Validaciones Celular

  const errorMsg = document.querySelector("#errorMsg");

  // Mapeo de los errores
  const errorMap = [
    "Número inválido",
    "Código de país inválido",
    "Demasiado corto",
    "Demasiado largo",
    "Número inválido",
  ];

  // Inicializar intl-tel-input
  const iti = window.intlTelInput(filled_error_celular, {
    initialCountry: "co",
    separateDialCode: true,
    utilsScript:
      "https://cdn.jsdelivr.net/npm/intl-tel-input@23.7.3/build/js/utils.js",
  });

  // Solo permitir números en el campo de entrada
  filled_error_celular.addEventListener("input", (event) => {
    // Reemplazar cualquier carácter que no sea número
    filled_error_celular.value = filled_error_celular.value.replace(/\D/g, "");
  });
  const reset = () => {
    filled_error_celular.classList.remove("error");
    errorMsg.classList.add("hidden");
    filled_error_help_tel.classList.add("hidden");
  };

  const showError = (msg) => {
    filled_error_celular.classList.add("error");
    errorMsg.textContent = msg;
    errorMsg.classList.remove("hidden");
    filled_error_help_tel.classList.add("hidden");
  };

  const showValid = () => {
    errorMsg.classList.add("hidden");
    filled_error_help_tel.classList.add("hidden");
  };

  document
    .getElementById("form-contact-chat")
    .addEventListener("submit", (event) => {
      reset(); // Reinicia los estados de error y validez
      if (filled_error_celular.value.trim() === "") {
        filled_error_help_tel.classList.remove("hidden");
        filled_error_celular.classList.add(...errorColor);
      } else if (iti.isValidNumber()) {
        showValid(); // Muestra mensaje de número válido
        filled_error_celular.classList.remove(...errorColor);
      } else {
        filled_error_help_tel.classList.add("hidden");
        filled_error_celular.classList.add(...errorColor);
        const errorCode = iti.getValidationError();
        const msg = errorMap[errorCode] || "Número inválido";
        showError(msg); // Muestra el mensaje de error correspondiente
        event.preventDefault();
      }
    });
});